import React, { useState, useEffect, createContext, useContext } from 'react';
import HomePage        from './pages/HomePage';
import AdminDashboard  from './pages/AdminDashboard';
import SchoolDashboard from './pages/SchoolDashboard';
import EventPage       from './pages/EventPage';
import './App.css';

export const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

function App() {
  const [user, setUser] = useState(null);
  const [page, setPage] = useState('home');
  const [eventId, setEventId] = useState(null);

  useEffect(() => {
    // Check for shared event link: ?event=<eventId>
    const params = new URLSearchParams(window.location.search);
    const eid = params.get('event');
    if (eid) { setEventId(eid); setPage('event'); return; }

    const saved = localStorage.getItem('dcUser');
    if (saved) {
      const u = JSON.parse(saved);
      setUser(u);
      // Only non-parent users restore to dashboard view
      if (u.userType !== 'parent') setPage('dashboard');
    }
  }, []);

  const login = (userData) => {
    setUser(userData);
    localStorage.setItem('dcUser', JSON.stringify(userData));
    // Parents stay on the home page
    if (userData.userType !== 'parent') setPage('dashboard');
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('dcUser');
    setPage('home');
  };

  const renderPage = () => {
    if (page === 'event' && eventId) {
      return (
        <EventPage
          eventId={eventId}
          onBack={() => { window.history.pushState({}, '', '/'); setEventId(null); setPage('home'); }}
        />
      );
    }
    if (page === 'home') {
      return (
        <HomePage
          user={user}
          onLogin={login}
          onDashboardClick={() => setPage('dashboard')}
        />
      );
    }
    if (page === 'dashboard') {
      if (user?.userType === 'admin')  return <AdminDashboard />;
      if (user?.userType === 'school') return <SchoolDashboard />;
      // parents have no separate dashboard – keep them on home
    }
    return (
      <HomePage
        user={user}
        onLogin={login}
        onDashboardClick={() => setPage('dashboard')}
      />
    );
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      <div className="dc-app">{renderPage()}</div>
    </AuthContext.Provider>
  );
}

export default App;